import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import {
  isFirmaSubmitLocked,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from 'src/app/_helpers/firma-submit.guard';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from "@angular/core";
import { formatDate } from "@angular/common";
import { MatLegacyPaginator as MatPaginator } from "@angular/material/legacy-paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DestinatarioDto } from "../destinatario_model";
import { PdfgenerateJustificanteNotificaService } from "../../_services/pdfgenerateJustificanteNotificaService/pdfgenerate-justificante-notifica.service";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { Destinatario } from "../../model/notificaresumen";
import { NotificationService } from "../../_services/notification.service";
import { TokenStorageService } from "../../_services/token-storage.service";
import { ServicioGeneral } from "../../_services/servicio-general.service";
import * as CryptoJS from "crypto-js";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ClaveService } from "src/app/_services/clave.service";
import { SamlRequest } from "src/app/model/samltoken";
import { Subscription } from "rxjs";
import { NavService } from "src/app/boton-listado/boton-listado.component.service";
import { UserService } from "src/app/_services/user.service";
import { ClientFirmaLogService } from "src/app/_services/client-firma-log.service";
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
import { NotificationReadService } from "src/app/_services/notificacion-read.service";
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
declare const AutoScript: any;
declare const Constants: any;

@Component({
  selector: "app-notificaciones-usuario",
  templateUrl: "./notificaciones-usuario.component.html",
  styleUrls: ["./notificaciones-usuario.component.scss"],
})
export class NotificacionesUsuarioComponent extends UnsubscribeOnDestroy implements OnInit {
  notificaciones: Destinatario[] | null = null;
  notificacionesDto: DestinatarioDto[] = [];
  displayedColumns: string[] = [
    "Identificador",
    "Fecha disposición",
    "Fecha rechazo automático",
    "Entidad",
    "Tipo",
    "Tipo receptor",
    "Descripción",
  ];
  dataSource = new MatTableDataSource<DestinatarioDto>();
  notificacionActivada: Destinatario;
  loading: boolean = false;
  selectedOpcion: String = "Firmar con Autofirma";
  diasCaducidad: string = localStorage.getItem(
    "notificacionesPendientesMaxDays"
  );
  displayFirma: string = "none";
  firmaResultLocked = false;
  subscription: Subscription;
  notificacionSelected: Destinatario;
  private spinnerHideTimer: ReturnType<typeof setTimeout> | null = null;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (sort) { this.dataSource.sort = sort; }
  }
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    if (paginator) { this.dataSource.paginator = paginator; }
  }

  get totalNotificaciones(): number { return this.dataSource?.data?.length || 0; }
  get notificacionesMostradas(): number { return this.dataSource?.filteredData?.length ?? this.totalNotificaciones; }

  constructor(
    private pdfJustificante: PdfgenerateJustificanteNotificaService,
    private notificationI18n: NotificationI18nService,
    private _tokenStorageService: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private _router: Router,
    private spinner: NgxSpinnerService,
    private _claveService: ClaveService,
    private _route: ActivatedRoute,
    private _navService: NavService,
    private _servicioUsuario: UserService,
    private _clientFirmaLog: ClientFirmaLogService,
    private _notificacionRead: NotificationReadService,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    super();
  }

  ngOnInit(): void {
    this.misNotificaciones();
    this.subscription = this._navService.navItem$
      .pipe(takeUntil(this.destroy$))
      .subscribe((item) => {
      this.selectedOpcion = item;
    });
  }

  acceptButton(notificacion) {
    this.displayFirma = "block";
    notificacion.aceptar = true;
    this.notificacionActivada = notificacion;
    
  }
  rechazoButton(notificacion) {
    this.displayFirma = "block";
    notificacion.aceptar = false;
    this.notificacionActivada = notificacion;
  }
  closeButton() {
    this.displayFirma = "none";
    this.notificacionActivada = null;
  }

  misNotificaciones(): void {
    this._servicioGeneral
      .postNotificaNotificaciones({ estado: "PENDIENTE", tipoEnvio: 2 })
      
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (response) => {
          if (response.respuesta.code == "200") {
            const list = (response.envios.titular ?? []).concat(
              response.envios.destinatario ?? []
            );
            this.notificaciones = list;
            this.notificacionesDto = list.map((item) => ({
              Id: item.envio,
              Identificador: item.identificador,
              "Fecha disposición": item.fecha_disposicion
                ? new Date(this.formatoFecha(item.fecha_disposicion))
                : undefined,
              "Fecha rechazo automático": item.fecha_caducidad
                ? new Date(this.formatoFecha(item.fecha_caducidad))
                : undefined,
              Entidad: item.organismo_emisor,
              Tipo: item.tipo_envio?.nombre ?? "",
              "Tipo receptor": item.tipoReceptor ?? "",
              Descripción: item.descripcion ?? "",
              Destinatario: item,
            }));
            this.dataSource.data = this.notificacionesDto;
          } else {
            this.notificationI18n.infoDynamic(response.respuesta, 4000);
            this.notificaciones = [];
            this.notificacionesDto = [];
            this.dataSource.data = [];
          }
        },
        error: (err) => {
          this.notificaciones = [];
          this.notificacionesDto = [];
          this.dataSource.data = [];
          this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_CARGAR_LAS_NOTIFICACIONES');
        },
      });
  }

  notificacionAcept() {
    this.mostrarSpinnerMsg("Solicitando firma");
    this.loading = true;
    // Cierra el modal de opción de firma al iniciar el proceso.
    this.displayFirma = "none";

    // navItem$ arranca en "" y tipofirma se carga async: vacío → Autofirma por defecto.
    const opcion = (this.selectedOpcion || "").toString().trim();
    const usarAutofirma = !opcion || opcion === "Firmar con Autofirma";

    // notificacion.csv = CryptoJS.HmacSHA256(this._tokenStorageService.dataUserForm.numero_documento+notificacion.identificador, 'SHA256').toString().slice(0,39);
    if (usarAutofirma) {
      this.signAutoFirma(this.notificacionActivada);
    } else {
      this.firmarClave(this.notificacionActivada.envio);
    }

    //this.singFile(dataB64); //firmar antes de enviar*/
  }

  signAutoFirma(notificacion) {
    const pdfDocGenerator = pdfMake.createPdf(
      this.pdfJustificante.objetPDF(notificacion)
    );

    this.notificacionActivada = notificacion;
    //pdfDocGenerator.open()
    pdfDocGenerator.getBase64((data) => {
      this._servicioGeneral
        .generateCSVNotificacion({ base64: data })
        
          .pipe(takeUntil(this.destroy$))
          .subscribe({
          next: (response) => {
            if (!response?.CSV) {
              this.loading = false;
              this.ocultarSpinner();
              this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_GENERAR_EL_DOCUMENTO_A_FIRMAR', 5000);
              this.misNotificaciones();
              return;
            }
            notificacion.csv = response.CSV;

            const pdfWithCSV = pdfMake.createPdf(
              this.pdfJustificante.objetPDF(notificacion)
            );

            this.notificacionActivada = notificacion;

            pdfWithCSV.getBase64((dataB64) => {
              // Autofirma necesita la UI libre; el spinner se reabre al enviar el justificante.
              this.ocultarSpinner();
              this._clientFirmaLog.iniciada(notificacion.envio, 'notificaciones-usuario');
              this.singFile(dataB64);
            });
          },
          error: () => {
            this.loading = false;
            this.ocultarSpinner();
            this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_GENERAR_EL_DOCUMENTO_A_FIRMAR', 5000);
            this.misNotificaciones();
          }
        });
    });
  }

  firmarClave(id) {
    let tipo = this.notificacionActivada.aceptar? 2:3;
    this._claveService.iniciaFirma(id,tipo)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: async (data: SamlRequest) => {
        this.post(data.nodeService, {
          SAMLRequest: data.SamlRequest,
          RelayState: data.RelayState,
        });
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
        this.ocultarSpinner();
        this.misNotificaciones();
      },
    });
  }

  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }

  notificacionReject(notificacion: Destinatario) {
    this.loading = true;
    this._servicioGeneral.getNotificaReject(notificacion.envio)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (response) => {
        if (response.code == "200") {
          var continueTramite = response.canContinueRegister ?? true;
          if(!continueTramite){
            this.notificationI18n.errorDynamic(response, 5000);
          }  
          else{
            this.notificationI18n.successDynamic(response, 4000);
          }
          this._notificacionRead.updateAlertMap();

          let reload = this._router.url;

          if (reload.includes("?action")) {
            const parts = reload.split("?");
            reload = parts[0];
          }

          reload = reload.concat("?action=34");
          console.log(reload);
          
          this._router
            .navigate(["inicio"], { skipLocationChange: true })
            .then(() => {
              this._router.navigateByUrl(reload);
            });
        } else {
          this.loading = false;
          this.notificationI18n.infoDynamic(response, 4000);
        }
      },
      error: (err) => {
        this.loading = false;
        this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_CARGAR_LAS_NOTIFICACIONES');
      },
    });
  }

  formatoFecha(date) {
    if (date) {
      let month = date[1] ? (date[1] < 10 ? "0" + date[1] : date[1]) : "";
      let day = date[2] ? (date[2] < 10 ? "0" + date[2] : date[2]) : "";
      let year = date[0];
      let hour = date[3] < 10 ? "0" + date[3] : date[3];
      let min = date[4] < 10 ? "0" + date[4] : date[4];
      let seg = date[5] ? (date[5] < 10 ? "0" + date[5] : date[5]) : "00";
      return [year, month, day].join("-").concat("T" + [hour, min, seg].join(":") + ".000Z");
    }
    return "";
  }

  formatDate(date: Date): string {
    if (!date || isNaN(date.getTime())) {
      return "";
    }
    return formatDate(date, "dd-MM-yyyy HH:mm", this.locale, "GMT");
  }

  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(
        Constants.URL_BASE_SERVICES +
          "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES +
          "/afirma-signature-retriever/RetrieveService"
      );
      AutoScript.sign(
        data != undefined && data != null && data != "" ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback
      );
    } catch (e) {
      this._clientFirmaLog.noDisponible(this.notificacionActivada?.envio, 'notificaciones-usuario');
      this.notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO');
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById("certifcado") as HTMLInputElement).value = certB64;
    (document.getElementById("result") as HTMLInputElement).value = filenameB64;
    (document.getElementById("error") as HTMLInputElement).value = "";
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }
  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.notificacionActivada?.envio, 'notificaciones-usuario', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById("certifcado") as HTMLInputElement).value = "";
    (document.getElementById("result") as HTMLInputElement).value = "";
    (document.getElementById('error') as HTMLInputElement).value = errorMessage + ". Se ha habilitado la opción para firmar con Cl@ve" ;
    this.displayFirma = "none";
    this.ocultarSpinner();
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }

  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;
    this.ocultarSpinner();
    let base64Document = (document.getElementById("result") as HTMLInputElement)
      .value;
    let errorFirma = (document.getElementById("error") as HTMLInputElement)
      .value;

    if (errorFirma == "" && base64Document != "") {
      this.mostrarSpinnerMsg("Firmando y enviando documento...");
      let certificado = atob(
        (document.getElementById("certifcado") as HTMLInputElement).value
      );
      if (
        certificado.includes(
          this._tokenStorageService.getUser().numero_documento
        )
      ) {
        this._clientFirmaLog.exito(this.notificacionActivada?.envio, 'notificaciones-usuario');
        this.sendJustificante(base64Document);
      } else {
        releaseFirmaSubmitLock(this);
        this._clientFirmaLog.certificadoInvalido(this.notificacionActivada?.envio, 'notificaciones-usuario');
        this.loading = false;
        this.displayFirma = "none";
        this.notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
        this.ocultarSpinner();
        this.misNotificaciones();
      }
    } else {
      releaseFirmaSubmitLock(this);
      this._clientFirmaLog.error(this.notificacionActivada?.envio, 'notificaciones-usuario', undefined, errorFirma || 'Firma cancelada o fallida');
      this.loading = false;
      this.displayFirma = "none";
      this._servicioUsuario
        .clearCurrentTipoFirma()
        
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {});  
      this.notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_POR_FAVOR_COMPRUEBE_QUE_NO_DISPONE_DE_NINGUN_BLOQU');
      this.misNotificaciones();
    }
  }

  sendJustificante(base64Document) {
    this._servicioGeneral
      .postNotificaJustificante({
        base64: base64Document,
        mimeType: "aplication/pdf",
        nameDocument: `justificante_${this.notificacionActivada.identificador}.pdf`,
        id: this.notificacionActivada.envio,
        csv: this.notificacionActivada.csv,
        aceptar: this.notificacionActivada.aceptar
      })
      
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (value) => {
          const aceptar = this.notificacionActivada?.aceptar;
          var continueTramite = value.canContinueRegister ?? true;
          if(!continueTramite){
            this.notificationI18n.errorDynamic(value, 5000);
          } else {
            this.notificationI18n.success(
              aceptar
                ? 'NOTIFICATION.MESSAGE.NOTIFICACION_ACEPTADA_CON_EXITO'
                : 'NOTIFICATION.MESSAGE.NOTIFICACION_RECHAZADA_CON_EXITO'
            );
          }
          releaseFirmaSubmitLock(this);
          this.loading = false;
          this.displayFirma = "none";
          this.notificacionActivada = null;
          this.ocultarSpinner();
          this.misNotificaciones();
          // Actualiza badges del menú (sin leer / contadores).
          this._notificacionRead.updateAlertMap();
          let reload = this._router.url;

          if (reload.includes("?action")) {
            const parts = reload.split("?");
            reload = parts[0];
          }

          reload = reload.concat("?action=33");

          this._router
            .navigate(["inicio"], { skipLocationChange: true })
            .then(() => {
              this._router.navigateByUrl(reload);
            });
        },
        error: (err) => {
          console.error(err);
          releaseFirmaSubmitLock(this);
          this.loading = false;
          this.displayFirma = "none";
          this.notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_SUBIR');
          this.ocultarSpinner();
          this.misNotificaciones();
        },
      });
  }
  //Apartado SPINNER
  mensajeSpinner: string = "";
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    if (this.spinnerHideTimer != null) {
      clearTimeout(this.spinnerHideTimer);
      this.spinnerHideTimer = null;
    }
    this.spinner.show('notificaciones_usuario_spinner');
  }
  ocultarSpinner() {
    if (this.spinnerHideTimer != null) {
      clearTimeout(this.spinnerHideTimer);
      this.spinnerHideTimer = null;
    }
    this.spinner.hide('notificaciones_usuario_spinner');
  }
}
